<div class="dashboard-container">
  <div class="left-container">
    <h1>{{course.title}}</h1>
    <div class="content-container">

      <app-text-card [text]="course.welcome_text" [title]="'Beschreibung'" [editable]="true" [onSaveAction]="onSave"></app-text-card>
      <div class="lesson-card-container">
        @if (lessons.length == 0) {
          <h2>Es konnten keine Lektionen geladen werden</h2>
        }
        @for (lesson of lessons; track lesson) {
          <mat-card class="lesson-card" (click)="navigateToLesson(lesson.id)">
            <mat-card-content>
              {{ lesson.title }}
            </mat-card-content>
            <mat-icon class="lesson-icon">chevron_right</mat-icon>
          </mat-card>
        }
        <div class="add-lesson" (click)="addLesson()">
          <span>Lektion hinzufügen</span>
          <mat-icon>add</mat-icon>
        </div>
      </div>
    </div>
  </div>
</div>